<!-- <div class="wrapper">
    <div class="cbm-nav-navbar">
        <div class="h2 font-weight-bold sidebar-title m-0 p-3 ">CBM</div>
    </div>
    <div class="sidebar" data-color="white"  >
        <sidebar-cmp></sidebar-cmp>
    </div>
    <div class="main-panel">
        <div class="content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div> -->

<div class="wrapper">
    <div class="sidebar" style="width: 260px !important;" data-color="white" data-active-color="danger">
        <sidebar-cmp style="width: 260px !important;"></sidebar-cmp>
    </div>
    <div class="main-panel primary-bg-color">
        <navbar-cmp></navbar-cmp>
        <div class="content">
            <router-outlet></router-outlet>
        </div>
        <!-- <footer-cmp></footer-cmp> -->
    </div>
</div>
    <!-- <fixedplugin-cmp></fixedplugin-cmp> -->
